import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  ReadingContent,
  CreateReadingContentDto,
  UpdateReadingContentDto,
  CreateReadingBlockDto,
  UpdateReadingBlockDto,
  ReorderBlocksDto,
  ReadingBlock,
} from "./reading-content.types";

const BASE_URL = "/reading-content";

export const getReadingContentByResourceId = async (
  resourceId: number,
): Promise<ReadingContent | null> => {
  try {
    const response: AxiosResponse<ReadingContent> = await api.get(
      `${BASE_URL}/resource/${resourceId}`,
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    // 404 means no reading content exists yet — not an error
    if (error?.response?.status === 404) {
      return null;
    }
    console.error("Error fetching reading content:", error);
    return null;
  }
};

export const createReadingContent = async (
  dto: CreateReadingContentDto,
): Promise<ReadingContent | null> => {
  try {
    const response: AxiosResponse<ReadingContent> = await api.post(
      BASE_URL,
      dto,
    );
    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error("Error creating reading content:", error);
    throw error;
  }
};

export const updateReadingContent = async (
  id: number,
  dto: UpdateReadingContentDto,
): Promise<ReadingContent | null> => {
  try {
    const response: AxiosResponse<ReadingContent> = await api.patch(
      `${BASE_URL}/${id}`,
      dto,
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error("Error updating reading content:", error);
    throw error;
  }
};

export const deleteReadingContent = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.status === 200;
  } catch (error: any) {
    console.error("Error deleting reading content:", error);
    throw error;
  }
};

export const addBlock = async (
  readingContentId: number,
  dto: CreateReadingBlockDto,
): Promise<ReadingBlock | null> => {
  try {
    const response: AxiosResponse<ReadingBlock> = await api.post(
      `${BASE_URL}/${readingContentId}/blocks`,
      dto,
    );
    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error("Error adding block:", error);
    throw error;
  }
};

export const updateBlock = async (
  readingContentId: number,
  blockId: number,
  dto: UpdateReadingBlockDto,
): Promise<ReadingBlock | null> => {
  try {
    const response: AxiosResponse<ReadingBlock> = await api.patch(
      `${BASE_URL}/${readingContentId}/blocks/${blockId}`,
      dto,
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error("Error updating block:", error);
    throw error;
  }
};

export const deleteBlock = async (
  readingContentId: number,
  blockId: number,
): Promise<boolean> => {
  try {
    const response = await api.delete(
      `${BASE_URL}/${readingContentId}/blocks/${blockId}`,
    );
    return response.status === 200;
  } catch (error: any) {
    console.error("Error deleting block:", error);
    throw error;
  }
};

export const reorderBlocks = async (
  readingContentId: number,
  dto: ReorderBlocksDto,
): Promise<boolean> => {
  try {
    const response = await api.patch(
      `${BASE_URL}/${readingContentId}/blocks/reorder`,
      dto,
    );
    return response.status === 200;
  } catch (error: any) {
    console.error("Error reordering blocks:", error);
    throw error;
  }
};
